import { ReducersMapObject, Reducer, Middleware } from "redux";

export interface EntityReducers {
  [key: string]: Array<Reducer<any>>;
}
export interface EntityReducersArg {
  [key: string]: Reducer<any> | Array<Reducer<any>>;
}

export type Listener = (reducers: ReducersMapObject) => void;

export default class ReducerRegistry {
  private reducers: ReducersMapObject;
  private listener: Listener | undefined;
  private middlewares: Middleware[];

  constructor(reducers: ReducersMapObject = {}) {
    this.reducers = {};
    this.middlewares = [];
    this.register(reducers);
    this.listener = undefined;
  }

  public register(reducers: ReducersMapObject, middlewares: Middleware[] = []) {
    this.reducers = { ...this.reducers, ...reducers };
    this.middlewares.push(...middlewares);
    if (this.listener) {
      this.listener(this.getReducers());
    }
  }

  public getReducers() {
    return this.reducers;
  }

  public getMiddlewares() {
    return this.middlewares;
  }

  public setChangeListener(listener: Listener) {
    this.listener = listener;
  }
}

export const reducerRegistry = new ReducerRegistry();



// WEBPACK FOOTER //
// ./frontend/src/lib/ReducerRegistry.ts